import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-claim-item-liability-limit',
  templateUrl: './claim-item-liability-limit.component.html',
  standalone: false,
})
export class ClaimItemLiabilityLimitComponent {
  @Input() isLiabilityPerClaim = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() item: any | null = null;
}
